import { NgModule } from '@angular/core';
import { DateModelPipe } from './date-model.pipe';


@NgModule({
    imports: [
        DateModelPipe,
    ],
    providers: [
        DateModelPipe,
    ],
    exports: [
        DateModelPipe,
    ],
})
export class DateModule {}
